export default __webpack_public_path__ + "static/rightArrowIcon-16dfddaaba9c689039d1e62072271329.png";